import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PrismHeader } from '@prism-ui/angular';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../core/services/auth.service';
import { environment } from '../../../environments/environment';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [PrismHeader],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
   private msalSub?: Subscription;
  userName: string = '';
  logOutUrl = environment.msal.logOutURL; // <-- Add this line to set the logout URL from environment
  constructor(private router: Router, private authService: AuthService,
     private msalBroadcastService: MsalBroadcastService
  ) { }

  menuItems = [
   
    {
      id: 'report',
      title: 'Report',
      active: false,
      href: '/report'
    },
    {
      id: 'my-billing',
      title: 'My Billing',
      active: false,
      href: '/my-billing'
    },
     {
      id: 'create-billing',
      title: 'Create Request',
      active: true,
      href: '/create-billing'
    },
    {
      id: 'help',
      title: 'help',
      active: false,
      href: '/help'
    }
  ];

  ngOnInit(): void {
    // Initialize with current route
    this.userName = this.authService.getUserName();
    this.updateActiveMenuFromRoute(this.router.url);
   
    // Listen to route changes and update userName after each navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateActiveMenuFromRoute(event.urlAfterRedirects);
        this.userName = this.authService.getUserName();
      });

     this.msalSub =   this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) =>
        msg.eventType === EventType.LOGIN_SUCCESS ||
        msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        msg.eventType === EventType.HANDLE_REDIRECT_END
      )
    )
    .subscribe(() => {
      this.userName = this.authService.getUserName();
    });
  }

  setActiveMenu(event: any) {
    const item = event?.detail || event; // Handle different event structures

    if (!item || !item.id) {
      return;
    }
    // Update active state
    this.menuItems.forEach(menuItem => {
      menuItem.active = menuItem.id === item.id;
    });
    
    // Navigate to the selected route
    if (item.href) {
      // Open help page in new tab to maintain reference while working
      if (item.id === 'help') {
        window.open(item.href, '_blank');
      } else {
        this.router.navigate([item.href]);
      }
    }
  }

  ngOnDestroy(): void {
    this.msalSub?.unsubscribe();
  }

  private updateActiveMenuFromRoute(url: string): void {
    this.menuItems = this.menuItems.map(menuItem => ({
      ...menuItem,
      active: url.includes(menuItem.href)
    }));
  }
}
